import type {
  TListDataBlock,
  TListDataBlockKey,
} from 'app/KinerjaKSPage/components/CardDataConfirmation/utils/types'

/*
 * Dialog Konfirmasi data atasan Anda
 * PS: Radio button nya muncul saat data available (not null), dan DATA TIM KERJA ditulis "Tidak ada data", design menyusul
 * Dinas: Radio button nya muncul saat data available (not null), dan DATA KEPALA DINAS PENDIDIkan ditulis "Tidak ada data", design menyusul
 */

// Kalau datanya tidak ada, tetep muncul di confirmation tapi icon nya beda, tbc.

const blockVariants: Record<string, TListDataBlock> = {
  CONFIRM: {
    type: 'CONFIRM',
    title: 'Konfirmasi data Tim Kinerja dan Pejabat Penilai Kinerja Anda',
    description:
      'Mohon segera konfirmasi data agar Pengelolaan Kinerja Anda dapat dilakukan.',
    button: {
      color: 'black',
      variant: 'solid',
      children: 'Konfirmasi data',
    },
    className: 'border border-blue-70 bg-blue-5',
    icon: 'supervisor_account_outline',
  },
  RECONFIRM_BLUE: {
    type: 'RECONFIRM',
    title: 'Konfirmasi data Tim Kinerja dan Pejabat Penilai Kinerja berhasil!',
    description: 'Anda akan melanjutkan Pengelolaan Kinerja dengan data:',
    button: {
      color: 'white',
      variant: 'solid',
      children: 'Konfirmasi ulang',
      className: '!bg-transparent',
    },
    className: 'border border-blue-70 bg-blue-5',
    icon: 'supervisor_account_outline',
  },
  RECONFIRM_YELLOW: {
    type: 'RECONFIRM',
    title:
      'Anda akan melanjutkan Pengelolaan Kinerja bersama Pejabat Penilai Kinerja',
    description:
      'Data salah mungkin disebabkan oleh data belum akurat di Simtendik atau ada kendala di pengaliran data. Saat ini, Anda akan melanjutkan Pengelolaan Kinerja dengan data:',
    button: {
      color: 'white',
      variant: 'solid',
      children: 'Konfirmasi ulang',
      className: '!bg-transparent',
    },
    className: 'border border-orange-40 bg-orange-10',
    icon: 'supervisor_account_outline',
  },
  RECONFIRM_RED: {
    type: 'RECONFIRM',
    title: 'Penting! Pengelolaan Kinerja tertunda',
    description:
      'Data salah mungkin disebabkan oleh data belum akurat di Simtendik atau ada kendala di pengaliran data. Anda tetap dapat melanjutkan Pengelolaan Kinerja, namun saat ini penilaian Anda tertunda.',
    button: {
      color: 'white',
      variant: 'solid',
      children: 'Konfirmasi ulang',
      className: '!bg-transparent',
    },
    className: 'border border-red-60 bg-red-5',
    icon: 'warning_outline',
  },
  NONE_RED: {
    type: 'NONE',
    title: 'Penting! Pengelolaan Kinerja tertunda',
    description:
      'Data Tim Kinerja dan Pejabat Penilai Kinerja Anda tidak dapat ditemukan. Anda tetap dapat melanjutkan Pengelolaan Kinerja, namun saat ini penilaian Anda tertunda.',
    button: null,
    className: 'border border-red-60 bg-red-5',
    icon: 'warning_outline',
  },
}

export const blocks: Record<TListDataBlockKey, TListDataBlock> = {
  // UNCONFIRMED: Not yet confirmed, or it's updated on (eg. PS replaced with someone new)
  // CONFIRMED: Confirmed, and the data is correct
  // REJECTED: Confirmed, and the data is incorrect
  // NULL: No data available

  PS_UNCONFIRMED_DINAS_UNCONFIRMED: blockVariants.CONFIRM,
  PS_UNCONFIRMED_DINAS_CONFIRMED: blockVariants.CONFIRM,
  PS_UNCONFIRMED_DINAS_REJECTED: blockVariants.CONFIRM,
  PS_UNCONFIRMED_DINAS_NULL: blockVariants.CONFIRM,

  PS_CONFIRMED_DINAS_UNCONFIRMED: blockVariants.CONFIRM,
  PS_CONFIRMED_DINAS_CONFIRMED: blockVariants.RECONFIRM_BLUE,
  PS_CONFIRMED_DINAS_REJECTED: blockVariants.RECONFIRM_BLUE,
  PS_CONFIRMED_DINAS_NULL: blockVariants.RECONFIRM_BLUE,

  PS_REJECTED_DINAS_UNCONFIRMED: blockVariants.CONFIRM,
  PS_REJECTED_DINAS_CONFIRMED: blockVariants.RECONFIRM_YELLOW,
  PS_REJECTED_DINAS_REJECTED: blockVariants.RECONFIRM_RED,
  PS_REJECTED_DINAS_NULL: blockVariants.RECONFIRM_RED,

  PS_NULL_DINAS_UNCONFIRMED: blockVariants.CONFIRM,
  PS_NULL_DINAS_CONFIRMED: blockVariants.RECONFIRM_BLUE,
  PS_NULL_DINAS_REJECTED: blockVariants.RECONFIRM_RED,
  PS_NULL_DINAS_NULL: blockVariants.NONE_RED, // Without "Konfirmasi ulang" button
}
